import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  generateNGOAdmin,
  getNGOProfileAdmin,
  getAllNGOAdmin,
  deleteNGOAdmin,
} from "appState/api/admin/admin";

export const adminGenerateNgo = createAsyncThunk(
  "admin/adminGenerateNGO",
  generateNGOAdmin
);
export const adminGetNGOProfile = createAsyncThunk(
  "admin/adminGetNGOProfile",
  getNGOProfileAdmin
);
export const adminGetAllNGO = createAsyncThunk(
  "admin/adminGetAllNGO",
  getAllNGOAdmin
);
export const adminDeleteNGO = createAsyncThunk(
  "admin/adminDeleteNGO",
  deleteNGOAdmin
);

const initialState = {
  isLoading: false,
  adminNGO: [],
  adminNGOProfile: {},
};

export const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(adminGenerateNgo.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(adminGenerateNgo.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(adminGenerateNgo.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(adminGetNGOProfile.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(adminGetNGOProfile.fulfilled, (state, action) => {
      state.isLoading = false;
      // state.adminNGOProfile = action.payload?.data?.project;
    });
    builder.addCase(adminGetNGOProfile.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(adminGetAllNGO.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(adminGetAllNGO.fulfilled, (state, action) => {
      state.isLoading = false;
      // state.adminNGO = action.payload?.data?.project;
    });
    builder.addCase(adminGetAllNGO.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(adminDeleteNGO.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(adminDeleteNGO.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(adminDeleteNGO.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default adminSlice.reducer;
